<template>
    <CountryCode :id="id" :modelValue="nationCode" @update:modelValue="updateNationCode"></CountryCode>
    <input type="text" :id="id" @input="updatePhoneNo" class="form-control" maxlength="13" :required="required">
</template>

<script>
import CountryCode from "@/components/control/CountryCode.vue";

export default {
    props: {
        id: String,
        modelValue: String,
        required: {
          type: Boolean,
          default: false
        }
    },
    components: {
        CountryCode: CountryCode
    },
    data() {
        return {
            nationCode: "82",
            phoneNo: ""
        }
    },
    methods: {
        // 국가코드 업데이트
        updateNationCode(value) {
            this.nationCode = value;
            this.$emit("update:modelValue", "+" + this.nationCode + " " + this.phoneNo);
        },
        // 전화번호 업데이트
        updatePhoneNo(event) {
            this.phoneNo = event.target.value;
            this.$emit("update:modelValue", "+" + this.nationCode + " " + this.phoneNo);
        }
    }
}
</script>
